/**
 * Aegis logomark — a primitive shield silhouette in the brand amber.
 * Phase 2 of the frontend redesign — see
 * docs/plans/2026-04-28-frontend-redesign.md §3 (visual language) and §10
 * (Brand and voice — the previous design had no logomark anywhere).
 */

interface ShieldProps {
  size?: number
  className?: string
}

export function Shield({ size = 16, className = '' }: ShieldProps) {
  return (
    <span
      role="img"
      aria-label="Aegis"
      className={`inline-block bg-amber ${className}`}
      style={{
        width: size - 2,
        height: size,
        clipPath: 'polygon(50% 0, 100% 22%, 100% 65%, 50% 100%, 0 65%, 0 22%)',
      }}
    />
  )
}
